import { render } from "./RecipeBottomNav.vue?vue&type=template&id=733555a6&scoped=true"
import script from "./RecipeBottomNav.vue?vue&type=script&lang=js"
export * from "./RecipeBottomNav.vue?vue&type=script&lang=js"

import "./RecipeBottomNav.vue?vue&type=style&index=0&id=733555a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733555a6"]])

export default __exports__